// @flow
import React from 'react';
// eslint-disable-next-line import/named
import { type IntlShape, injectIntl } from 'react-intl';

import { Icon } from 'components/atoms/Icon/';

import './MessageBanner.scss';

const ns = 'message-banner';

type Props = {
  intl: IntlShape,
  content: any
};

const MessageBanner = (props: Props) => {
  const { intl, content } = props;
  return (
    <div className={`${ns}__banner-info py-2 d-flex flex-row`}>
      <div className={`d-flex align-items-center px-1 px-lg-2`}>
        <Icon
          type="light-bulb"
          className={`${ns}__icon`}
          id="light_bulb_icon"
          aria-label={intl.formatMessage({
            id: 'c8.aria.message.from.dealership',
            defaultMessage: 'Message from dealership'
          })}
        />
      </div>
      <div className={`${ns}__recommended-subtitle px-1 px-lg-2`}>
        {content}
      </div>
    </div>
  );
};

export default injectIntl(MessageBanner);



// WEBPACK FOOTER //
// ./src/components/atoms/MessageBanner/MessageBanner.js